// The service worker answers a page's first load from the device and fetches
// the API behind it (public/service-worker.js); when the API's answer
// differs, it posts this, naming the response's URL, so the page can fetch
// the copy it just stored.
export const API_UPDATED = "khipur:api-updated";

export const onApiUpdated = (handler: (url: string) => void): (() => void) => {
  if (!("serviceWorker" in navigator)) return () => {};
  const { serviceWorker } = navigator;
  const listener = (event: MessageEvent) => {
    if (event.data?.type === API_UPDATED) handler(event.data.url);
  };
  serviceWorker.addEventListener("message", listener);
  return () => serviceWorker.removeEventListener("message", listener);
};
